import src from "IMAGE";
export default { src, width: 477, height: 99, blurWidth: 0, blurHeight: 0};
